<template>
  <Component :is="continuous ? 'div' : BaseCard" :class="containerClasses">
    <p id="candidateSocials"
       class="mb-8 w-24 bg-gradient-to-r bg-clip-text font-bold text-transparent from-bdOrange-600 to-bdYellow-600">
      Socials.</p>
    <div class="flex flex-wrap justify-start gap-4 pb-8 lg:gap-6"
         :class="editable ? 'items-center' : 'flex-col items-start'">
      <div v-if="showLinkedIn" class="flex items-center justify-start" :class="editable && 'w-full'">
        <img src="https://upload.wikimedia.org/wikipedia/commons/8/81/LinkedIn_icon.svg" alt="Linked Icon"
             class="mr-2 h-4 w-4"/>
        <FormInputPrefix v-if="editable" :model-value="candidate.linkedIn" :default-prefix="candidateSocials.linkedIn.prefixes[0]"
                         placeholder="john-doe" :prefixes="candidateSocials.linkedIn.prefixes"
                         dropdown-width-class="lg:w-96" @update:model-value="updateCandidate('linkedIn', $event)"/>
        <a v-else :href="'/redirect?link=' + candidate.linkedIn" target="_blank"
           class="text-sm text-slate-600 hover:underline">{{ candidate.linkedIn }}</a>
      </div>
      <div v-if="showInstagram" class="flex items-center justify-start" :class="editable && 'w-full'">
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Instagram.svg/240px-Instagram.svg.png"
             alt="Instagram Icon" class="mr-2 h-4 w-4"/>
        <FormInputPrefix v-if="editable" :model-value="candidate.instagram" :default-prefix="candidateSocials.instagram.prefixes[0]"
                         placeholder="john-doe" :prefixes="candidateSocials.instagram.prefixes"
                         dropdown-width-class="lg:w-96" @update:model-value="updateCandidate('instagram', $event)"/>
        <a v-else :href="'/redirect?link=' + candidate.instagram" target="_blank"
           class="text-sm text-slate-600 hover:underline">{{ candidate.instagram }}</a>
      </div>
      <div v-if="showFacebook" class="flex items-center justify-start" :class="editable && 'w-full'">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Facebook_logo_%28square%29.png/240px-Facebook_logo_%28square%29.png"
          alt="Facebook Icon" class="mr-2 h-4 w-4"/>
        <FormInputPrefix v-if="editable" :model-value="candidate.facebook" :default-prefix="candidateSocials.facebook.prefixes[0]"
                         placeholder="john-doe" :prefixes="candidateSocials.facebook.prefixes"
                         dropdown-width-class="lg:w-96" @update:model-value="updateCandidate('facebook', $event)"/>
        <a v-else :href="'/redirect?link=' + candidate.facebook" target="_blank"
           class="text-sm text-slate-600 hover:underline">{{ candidate.facebook }}</a>
      </div>
      <div v-if="showWebsite" class="flex items-center justify-start" :class="editable && 'w-full'">
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Globe_icon.svg/240px-Globe_icon.svg.png"
             alt="Website Icon" class="mr-2 h-4 w-4"/>
        <FormInputPrefix v-if="editable" :model-value="candidate.website" :default-prefix="candidateSocials.website.prefixes[0]"
                         placeholder="example.com" :prefixes="candidateSocials.website.prefixes"
                         dropdown-width-class="w-36" @update:model-value="updateCandidate('website', $event)"/>
        <a v-else :href="'/redirect?link=' + candidate.website" target="_blank"
           class="text-sm text-slate-600 hover:underline">{{ candidate.website }}</a>
      </div>
    </div>
    <p v-if="notEditableAndNoLinks"
       class="-mt-10 mb-4 text-sm text-slate-400">No socials entered yet</p>
  </Component>
</template>

<script setup>
import BaseCard from "./BaseCard.vue";
import FormInputPrefix from "./FormInputPrefix.vue";
import {computed} from "vue";
import {candidateSocials} from "../helpers/ProfileQuestions.js";

const emits = defineEmits(["update:candidate"]);
const props = defineProps({
  candidate: Object,
  continuous: Boolean,
  small: Boolean,
  editable: Boolean,
});

const containerClasses = computed(() => {
  const baseClasses = props.continuous ? "px-4 md:px-6 mt-6" : "relative shadow-sm mt-6";
  return baseClasses + (props.small ? " text-sm" : " text-base");
});

const showLinkedIn = computed(() => props.editable || props.candidate.linkedIn);
const showInstagram = computed(() => props.editable || props.candidate.instagram);
const showFacebook = computed(() => props.editable || props.candidate.facebook);
const showWebsite = computed(() => props.editable || props.candidate.website);
const notEditableAndNoLinks = computed(() => !props.editable && !props.candidate.linkedIn && !props.candidate.instagram && !props.candidate.facebook && !props.candidate.website);

const updateCandidate = (key, value) => {
  const newCandidate = {...props.candidate};
  newCandidate[key] = value;
  emits("update:candidate", newCandidate);
};
</script>
